import React from "react";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import DefaultRecipeDetails from "pages/Content/Nutrition/Recipes/RecipeDetails";

class RecipeDetails extends React.Component<any> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <DefaultRecipeDetails />
      </Container>
    );
  }
}

export default RecipeDetails;
